module.exports = __webpack_public_path__ + "img/root111.0c409637.png";